import React, { useRef, useEffect, useState } from 'react'
import Placholder from './Placholder';

const Missions = "https://res.cloudinary.com/dwbshru0j/image/upload/v1787558376/Portfolio%20Website/Dashboard/missions_hgdyse.webp";
const Projects = "https://res.cloudinary.com/dwbshru0j/image/upload/v1787558376/Portfolio%20Website/Dashboard/projects_g4aw5i.webp";
const About = "https://res.cloudinary.com/dwbshru0j/image/upload/v1787558376/Portfolio%20Website/Dashboard/about_blpfwm.webp";
const bgAudio = "https://res.cloudinary.com/dwbshru0j/video/upload/v1786951441/Portfolio%20Website/Dashboard/tribe-drum-loop_yaj7fl.mp3";


function HeroSection({ audioEnabled }) {
  const audioRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    const links = [
      { rel: 'prefetch', href: '/gallery.html', as: 'document' },
      { rel: 'prefetch', href: 'https://res.cloudinary.com/dwbshru0j/raw/upload/v1787590993/Portfolio%20Website/Projects%20Gallery/gallery-style_fofb1i.css', as: 'stylesheet', crossOrigin: 'anonymous' },
      { rel: 'prefetch', href: 'https://res.cloudinary.com/dwbshru0j/raw/upload/v1787591190/Portfolio%20Website/Projects%20Gallery/gallery-script_qoleuk.js', as: 'script', crossOrigin: 'anonymous' },
      { rel: 'prefetch', href: 'https://res.cloudinary.com/dwbshru0j/raw/upload/v1773954992/Portfolio%20Website/Projects%20Gallery/data_prppna.json', as: 'fetch', crossOrigin: 'anonymous' },
      {
        rel: 'prefetch',
        href: 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js',
        as: 'script',
        crossOrigin: 'anonymous'
      },
      {
        rel: 'prefetch',
        href: 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.2/gsap.min.js',
        as: 'script',
        crossOrigin: 'anonymous'
      },
      {
        rel: 'prefetch',
        href: 'https://cdn.jsdelivr.net/npm/remixicon@4.2.0/fonts/remixicon.css',
        as: 'stylesheet',
        crossOrigin: 'anonymous'
      }
    ];

    const appendPrefetchLinks = () => {
      links.forEach(({ rel, href, as, crossOrigin }) => {
        const alreadyExists = document.head.querySelector(`link[rel="${rel}"][href="${href}"]`);
        if (alreadyExists) return;

        const link = document.createElement('link');
        link.rel = rel;
        link.href = href;
        if (as) link.as = as;
        if (crossOrigin) link.crossOrigin = crossOrigin;
        document.head.appendChild(link);
      });
    };

    const idleHandle =
      typeof window.requestIdleCallback === 'function'
        ? window.requestIdleCallback(appendPrefetchLinks, { timeout: 1500 })
        : window.setTimeout(appendPrefetchLinks, 300);

    return () => {
      if (typeof window.cancelIdleCallback === 'function' && typeof idleHandle === 'number') {
        window.cancelIdleCallback(idleHandle);
      } else {
        window.clearTimeout(idleHandle);
      }
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.muted = isMuted || !audioEnabled;
      audioRef.current.volume = audioEnabled ? 0.3 : 0;
    }
  }, [isMuted, audioEnabled]);

  const toggleMute = () => {
    setIsMuted(prev => !prev);
  };

  return (
    <div className='relative overflow-hidden'>

      {/* Background Audio */}
      <audio
        ref={audioRef}
        src={bgAudio}
        autoPlay
        loop
      />

      {/* Mute / Unmute Button */}
      <button
        onClick={toggleMute}
        className="fixed bottom-6 right-6 z-[50] px-4 py-2 rounded-lg 
                   bg-black/70 text-white backdrop-blur 
                   hover:bg-black transition"
      >
        {isMuted || !audioEnabled ? 'MUSIC OFF' : 'MUSIC ON'}
      </button>

      <div className='top-0 w-full grid grid-cols-3 overflow-hidden ml-10'>
        <Placholder
          videoSrc={About}
          projectName="About"
          details={"Who am I and What I do?"}
          audioEnabled={audioEnabled}
          className="z-[30]"
          link="/about"
        />

        <Placholder
          videoSrc={Missions}
          projectName="Missions"
          details={"Service Record & Command History"}
          audioEnabled={audioEnabled}
          className="-ml-7 z-[30] 2xl:-ml-10"
          link="/experience"
        />

        <Placholder
          videoSrc={Projects}
          projectName="Projects"
          details={"Field Deployments & Tactical Builds"}
          audioEnabled={audioEnabled}
          className="-ml-14 z-[30] 2xl:-ml-20"
          link="/projects"
        />
      </div>
    </div>
  )
}

export default HeroSection;
